import { render } from "./AdminPaymentmethodList.vue?vue&type=template&id=09712228&ts=true&lang=true"
import script from "./AdminPaymentmethodList.vue?vue&type=script&lang=ts"
export * from "./AdminPaymentmethodList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__